var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/VerticalThreeDots.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const VerticalThreeDots = ({
  color = '#A2A3B7',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 4 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M2.00001 3.79329C2.91668 3.79329 3.66668 3.04329 3.66668 2.12663C3.66668 1.20996 2.91668 0.459961 2.00001 0.459961C1.08334 0.459961 0.333344 1.20996 0.333344 2.12663C0.333344 3.04329 1.08334 3.79329 2.00001 3.79329ZM2.00001 5.45996C1.08334 5.45996 0.333344 6.20996 0.333344 7.12663C0.333344 8.04329 1.08334 8.79329 2.00001 8.79329C2.91668 8.79329 3.66668 8.04329 3.66668 7.12663C3.66668 6.20996 2.91668 5.45996 2.00001 5.45996ZM2.00001 10.46C1.08334 10.46 0.333344 11.21 0.333344 12.1266C0.333344 13.0433 1.08334 13.7933 2.00001 13.7933C2.91668 13.7933 3.66668 13.0433 3.66668 12.1266C3.66668 11.21 2.91668 10.46 2.00001 10.46Z",
    fill: color
  })
});